export const HEADER = ({
  HEADER_TITLE: 'Create new skeleton template',
  CLEAR_CANVAS: 'Clear canvas',
  SAVE_TEMPLATE: 'Save template'
} as const);
export const KEYPOINTS_PANEL = ({
  HEADING: 'Keypoints',
  EMPTY_TITLE: 'No keypoints added',
  EMPTY_DESCRIPTION: 'Access and manage the keypoints you add in the canvas here',
  DELETE_LABEL: (name: string) => `Delete ${name}`,
  WIDTH_PERCENTAGE: '25%',
  MIN_WIDTH: '280px'
} as const);
export const CANVAS = ({
  DEFAULT_STAGE_SETTINGS: {
    x: 0,
    y: 0,
    scale: 1,
    rotation: 0
  },
  NODE_RADIUS: 8,
  NODE_RING_WIDTH: 2,
  NODE_RING_WIDTH_HOVER: 6,
  NODE_LABEL_GAP: 8,
  EDGE_STROKE_WIDTH: 2,
  EDGE_HIT_AREA_WIDTH: 12,
  EDGE_HOVER_STROKE_WIDTH: 4,
  EDGE_PREVIEW_OPACITY: 0.5,
  INPUT_WIDTH: '180px',
  EDGE_FLIP_THRESHOLD: 0.75,
  PADDING: 40
} as const);
export const NODE_COLOR_PALETTE = (['#276EF1', '#05944F', '#E11900', '#FFC043', '#7356BF', '#F25C00', '#0E8784', '#E054B8', '#3AA76D', '#68D4F8', '#B4D455', '#F19B27', '#9B59B6', '#8E44AD', '#5D6D7E', '#F06292'] as const);
export const VERTICAL_ANCHOR = ({
  TOP: 'top',
  BOTTOM: 'bottom'
} as const);
export const HORIZONTAL_ANCHOR = ({
  LEFT: 'left',
  RIGHT: 'right'
} as const);
export const VERTICAL_ANCHOR_TRANSLATE = ({
  [VERTICAL_ANCHOR.TOP]: 'translateY(-100%)',
  [VERTICAL_ANCHOR.BOTTOM]: 'translateY(0)'
} as const);
export const CANVAS_TOOLBAR = ({
  ZOOM_IN: 'Zoom in',
  ZOOM_OUT: 'Zoom out',
  FIT_TO_SCREEN: 'Fit to screen',
  UNDO: 'Undo',
  REDO: 'Redo',
  ZOOM_IN_FACTOR: 1.1,
  ZOOM_OUT_FACTOR: 0.9,
  ICON_SIZE: 16
} as const);
export const PREVIEW = ({
  DEFAULT_NODE_COLOR: '#276EF1',
  PADDING: 30,
  DEFAULT_WIDTH: 300,
  DEFAULT_HEIGHT: 300,
  NODE_RADIUS: 4,
  LABEL_OFFSET: 10,
  LABEL_FONT_SIZE: 10
} as const);
export const REFERENCE_IMAGE = ({
  UPLOAD_TOOLTIP: 'Upload reference image',
  REMOVE_TOOLTIP: 'Remove reference image',
  DEFAULT_OPACITY: 0.5,
  MIN_OPACITY: 0.1,
  MAX_OPACITY: 1,
  OPACITY_STEP: 0.01,
  ICON_SIZE: 20,
  ACCEPTED_TYPES: 'image/*',
  SLIDER_WIDTH: '160px'
} as const);
export const VALIDATION = {
  MIN_NODES: 'Template must have at least 2 nodes',
  MIN_EDGES: 'Template must have at least 1 edge',
  INVALID_ASPECT_RATIO: 'Template bounding box aspect ratio must be greater than 0',
  NODE_BLANK_ID: (index: number) => `Node ${index + 1} must have an ID`,
  NODE_BLANK_LABEL: (index: number) => `Node ${index + 1} must have a label`,
  NODE_DUPLICATE_ID: (id: string) => `Duplicate node ID: "${id}"`,
  NODE_DUPLICATE_LABEL: (label: string) => `Duplicate node label: "${label}"`,
  NODE_POSITION_OUT_OF_RANGE: (label: string) => `Node "${label}" position is outside the canvas`,
  EDGE_BLANK_NODES: 'All edges must connect two nodes',
  EDGE_SELF_REFERENCE: (label: string) => `Edge cannot connect "${label}" to itself`,
  EDGE_INVALID_NODE: (nodeId: string) => `Edge references unknown node: "${nodeId}"`,
  EDGE_DUPLICATE: (source: string, target: string) => `Duplicate edge between "${source}" and "${target}"`
};